import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiTarget, FiUsers, FiTrendingUp } = FiIcons;

const usps = [
  {
    icon: FiShield,
    title: "Authority-First Structure",
    desc: "Every element is strategically placed to establish credibility before presenting your services."
  },
  {
    icon: FiTarget,
    title: "Local SEO by Design",
    desc: "Built-in optimization for Australian local search queries like '[Service] in [Suburb]'."
  },
  {
    icon: FiUsers,
    title: "Consumer Psychology",
    desc: "Structured to match how professionals and businesses are evaluated by high-value Australian clients."
  },
  {
    icon: FiTrendingUp,
    title: "Revenue Intent",
    desc: "Designed to attract and convert prospects who value premium expertise over the lowest price."
  }
];

const USP = () => {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
      {usps.map((usp, idx) => (
        <motion.div 
          key={idx} 
          initial={{ opacity: 0, y: 20 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          viewport={{ once: true }} 
          transition={{ delay: idx * 0.1 }} 
          className="glass-card p-8 flex flex-col items-center text-center group"
        >
          <div className="w-14 h-14 rounded-2xl bg-blue-500/10 flex items-center justify-center mb-6 group-hover:bg-blue-500/20 transition-colors">
            <SafeIcon icon={usp.icon} className="text-3xl text-blue-500" />
          </div>
          <h3 className="text-xl font-bold text-white mb-4 font-display">{usp.title}</h3>
          <p className="text-slate-400 text-sm leading-relaxed">{usp.desc}</p>
        </motion.div>
      ))}
    </div>
  );
};

export default USP;